import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderNoUserManagerProps } from 'react-oidc-context';
import { getAppConfiguration } from './app-configuration';

const redirectUri = window.location.origin;

export async function getOidcConfig(silentRedirectPath: string) {
    const { authAuthority, authClientId, authResource, authScope } = await getAppConfiguration();

    return {
        authority: authAuthority,
        client_id: authClientId,
        redirect_uri: redirectUri,
        scope: authScope,
        response_type: 'code',
        post_logout_redirect_uri: redirectUri,
        automaticSilentRenew: true,
        includeIdTokenInSilentRenew: true,
        silent_redirect_uri: `${redirectUri}${silentRedirectPath}`,
        loadUserInfo: false,
        extraQueryParams: { resource: authResource },
        extraTokenParams: { scope: authScope },
        userStore: new WebStorageStateStore({ store: window.localStorage }),
    } as AuthProviderNoUserManagerProps;
}

export async function getOidcSessionKey() {
    const { authAuthority, authClientId } = await getAppConfiguration();

    return `oidc.user:${authAuthority}:${authClientId}`;
}
